import React from 'react'
import { Helmet } from 'react-helmet'

const CustomHelmet = (props) => {
  const { url, title, description } = props

  const siteName = 'FlexoStack'
  const fullTitle = title ? `${title} | ${siteName}` : siteName

  const currentDomain = window.location.protocol + '//' + window.location.host
  const canonical = url === '/' ? currentDomain : `${currentDomain}${url}`

  const image = ''
  
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="robots" content="index,follow" />
      <link rel="canonical" href={canonical} />

      <html lang='en' />

      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:site_name" content={siteName} />
      { image && <meta property="og:image" content={image} /> }

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      { image && <meta name="twitter:image" content={image} /> }
    </Helmet>
  )
}

export default CustomHelmet